import styled from '@emotion/styled';
import { Link } from 'components/link';
import { Text, SmallText } from 'ds/components/typography';

export const Root = styled(Link)<{ isHovered?: boolean }>(({ theme, isHovered }) => ({
  display: 'flex',
  textDecoration: 'none',
  justifyContent: 'space-between',
  padding: theme.spacing(3, 4),
  backgroundColor: theme.colors.neutrals.white,
  borderRadius: theme.borderRadius.small,
  border: `1px solid ${theme.colors.neutrals.grey8}`,
  cursor: 'pointer',
  boxShadow: isHovered ? theme.shadow.level7 : 'none',
  transition: 'box-shadow 0.4s ease-in-out',
  [theme.media.createObjectMediaQuery({ at: 1 })]: {
    flexDirection: 'column',
    gap: theme.spacing(3),
  },
}));

export const Title = styled(Text)(({ theme }) => ({
  color: theme.colors.neutrals.grey1,
}));

export const SubTitle = styled(SmallText)(({ theme }) => ({
  color: theme.colors.neutrals.grey3,
  marginBottom: theme.spacing(1),
}));

export const LabelsBox = styled.div(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  gap: theme.spacing(1),
}));

export const Label = styled(SmallText)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(0, 0.75),
  color: theme.colors.neutrals.grey1,
  borderRadius: theme.borderRadius.tiny,
  border: `1px solid ${theme.colors.neutrals.grey6}`,
}));

export const MadlanIndexBox = styled.div(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(4),
  flexDirection: 'row-reverse',
  justifyContent: 'space-between',
}));

export const MadlanIndexTitle = styled(SmallText)<{ isActive: boolean }>(({ theme, isActive }) => ({
  minWidth: '61px',
  color: isActive ? theme.colors.insights.education : theme.colors.neutrals.grey3,
}));

export const MadlanIndexValue = styled(Text)<{ isActive: boolean }>(({ theme, isActive }) => ({
  color: isActive ? theme.colors.insights.education : theme.colors.neutrals.grey1,
}));
